var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg03D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 18H11.4762H20.381C21.254 18 23 17.5 23 15.5C23 14.6802 22.4931 13.0541 20.4821 13.0013C20.4268 12.9999 20.3812 12.9545 20.379 12.8993C20.2852 10.5336 16.899 9.12673 14.8094 11.745C14.7484 11.8214 14.6143 11.7803 14.6073 11.6828C14.4819 9.94496 13.3198 7 9.38095 7C7.64981 7 4.2023 7.98302 4.14362 11.8983C4.14279 11.9535 4.0981 11.9999 4.04291 12.0018C2.96784 12.0388 1 12.6741 1 15C1 16 1.62857 18 4.14286 18Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03D);
export default __webpack_public_path__ + "static/media/03d.896093ca7b92b2a347529ca8c6e3c413.svg";
export { ForwardRef as ReactComponent };